// pauseWords - the admin's words for a saved pass's stop reason (0064), in
// one home that every admin surface imports: the run page's SavedPassPanel,
// All runs, and the Alerts page, its header count and its browser
// notification (lib/adminAlerts.ts). A lib module, so lib/adminAlerts.ts can
// read it without importing a view.

// pauseReasonWords is the admin's words for a stop reason code.
export function pauseReasonWords(reason?: string): string {
  switch (reason) {
    case "usage_limit":
      return "usage limit";
    case "engine_auth_rejected":
      return "engine sign-in rejected";
    case "lost_hold":
      return "lost its hold on the spec";
    case "time_limit":
      return "hit the run time limit";
    case "machine_stopped":
      return "its machine stopped";
    default:
      return reason ?? "";
  }
}
